/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ListingVisitFormItem } from './ListingVisitFormItem';
import {
    ListingVisitFormItemFromJSON,
    ListingVisitFormItemFromJSONTyped,
    ListingVisitFormItemToJSON,
} from './ListingVisitFormItem';

/**
 * Response containing visit forms for a listing.
 * @export
 * @interface ListingVisitFormsResponse
 */
export interface ListingVisitFormsResponse {
    /**
     * Total visit forms for the listing
     * @type {number}
     * @memberof ListingVisitFormsResponse
     */
    total: number;
    /**
     * Visit forms scoped to the listing
     * @type {Array<ListingVisitFormItem>}
     * @memberof ListingVisitFormsResponse
     */
    visitForms: Array<ListingVisitFormItem>;
}

/**
 * Check if a given object implements the ListingVisitFormsResponse interface.
 */
export function instanceOfListingVisitFormsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "visitForms" in value;

    return isInstance;
}

export function ListingVisitFormsResponseFromJSON(json: any): ListingVisitFormsResponse {
    return ListingVisitFormsResponseFromJSONTyped(json, false);
}

export function ListingVisitFormsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListingVisitFormsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'visitForms': ((json['visit_forms'] as Array<any>).map(ListingVisitFormItemFromJSON)),
    };
}

export function ListingVisitFormsResponseToJSON(value?: ListingVisitFormsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'visit_forms': ((value.visitForms as Array<any>).map(ListingVisitFormItemToJSON)),
    };
}

